import styled from 'styled-components'

export const TypeText = styled.span`
  color: ${(props) => props.color};
  font-weight: 600;
`
